import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 59,
    s: 46
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) {
          s--;
        } else {
          s = 59;
          if (m > 0) {
            m--;
          } else {
            m = 59;
            if (h > 0) {
              h--;
            } else {
              clearInterval(timer);
              return {
                h: 0,
                m: 0,
                s: 0
              };
            }
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const Block = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="bg-[#0a0f1a] border border-gray-800 rounded-xl px-4 py-3 min-w-[72px] md:min-w-[88px] text-center" data-id="element-7">
      <div className="text-3xl md:text-5xl font-bold text-emerald-500 font-mono leading-none" data-id="element-8">
        {String(value).padStart(2, '0')}
      </div>
      <div className="text-[10px] md:text-xs text-gray-500 mt-1 uppercase tracking-widest font-sans font-medium" data-id="element-9">
        {label}
      </div>
    </div>;
  return <div className="flex items-center justify-center gap-2 md:gap-3" data-id="element-10">
      <Block value={timeLeft.h} label="hs" data-id="element-11" />
      <span className="text-2xl md:text-4xl text-gray-700 font-bold pb-4" data-id="element-12">
        :
      </span>
      <Block value={timeLeft.m} label="min" data-id="element-13" />
      <span className="text-2xl md:text-4xl text-gray-700 font-bold pb-4" data-id="element-14">
        :
      </span>
      <Block value={timeLeft.s} label="seg" data-id="element-15" />
    </div>;
}